import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { SubdomainApi } from './subdomain.api';
import { useStore } from '@app/store/useStore.hook';

const GET_MY_SUBDOMAINS = 'GET_MY_SUBDOMAINS';

export const useRegisterSubdomain = ({
  onSuccess,
  ...options
}: UseMutationOptions<{ subdomain?: string }, Error, { subdomain: string }> = {}) => {
  const queryClient = useQueryClient();
  const { getMe } = useStore(({ getMe }) => ({
    getMe,
  }));
  return useMutation(
    async ({ subdomain }) => {
      await SubdomainApi.register(subdomain);
      return { subdomain };
    },
    {
      onSuccess: async (data, variables, context) => {
        await getMe();

        await queryClient.invalidateQueries(GET_MY_SUBDOMAINS);
        onSuccess && (await onSuccess(data, variables, context));
      },
      ...options,
    }
  );
};
